/// <reference types="./properties.d.mts" />
import * as $unsafe from "../../../../common_common/gleam/unsafe.mjs";
import * as $decode from "../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $component from "../../../../lustre/lustre/component.mjs";
import * as $element from "../../../../lustre/lustre/element.mjs";

export function coerce(name, msg) {
  return $component.on_property_change(
    name,
    $decode.then$(
      $decode.dynamic,
      (data) => { return $decode.success(msg($unsafe.coerce(data))); },
    ),
  );
}

export function children(msg) {
  return coerce("children-nodes", msg);
}
